import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { isValidLength } from '@/lib/rule';
import { usePermissionComposable } from '@/composables/usePermission';
import { formatToDate } from '@/utils/datetime';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import DeleteIpAddress from '@/views/pages/ipAddressRestriction/DeleteIpAddress.vue';
import { CompanyWhiteListIpGetResponse } from '@/interfaces/api/general/company';
import store from '@/store';
import { readAssertedCompanyId } from '@/store/main/getters';
import { dispatchUpdateCompanyWhitelistIpName } from '@/store/main/actionsMain';
import { commitAddNotification } from '@/store/main/mutations';
import { AxiosError } from 'axios';

type WhitelistIpItem = CompanyWhiteListIpGetResponse['data'][number];


export default /*#__PURE__*/_defineComponent({
  __name: 'IpAddressTable',
  props: {
    ipAddressList: null
  },
  emits: ["refresh:ipAddressList"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'refresh:ipAddressList'): void;
}), expose: any, slots: any, attrs: any }) {





const m = defineMessages({
  editName: '名前の編集',
  editIpAddressName: 'IPアドレスの名前の編集',
  ipAddressNameUpdated: 'IPアドレスの名前を更新しました',
  deleteIpAddress: 'IPアドレスの削除',
});

const { hasPermission, PERMISSIONS: P } = usePermissionComposable();
const deleteTargetIpAddress = ref<string>();
const editTargetWhitelistIp = ref<WhitelistIpItem | undefined>();
const editName = ref('');
const isValidEditForm = ref(false);

const isNameChanged = computed(() => {
  return editName.value !== editTargetWhitelistIp.value?.name;
});

const openEditDialog = (whitelistIp: WhitelistIpItem) => {
  editTargetWhitelistIp.value = whitelistIp;
  editName.value = whitelistIp.name;
};

const closeEditDialog = () => {
  editTargetWhitelistIp.value = undefined;
};

const updateWhitelistIpName = async () => {
  if (!editTargetWhitelistIp.value) return;

  try {
    await dispatchUpdateCompanyWhitelistIpName(store, {
      companyId: readAssertedCompanyId(store),
      ipAddress: editTargetWhitelistIp.value.ip_address,
      payload: { name: editName.value },
    });
    commitAddNotification(store, {
      messageKey: m.ipAddressNameUpdated,
      color: 'success',
    });
    editTargetWhitelistIp.value = undefined;
    emits('refresh:ipAddressList');
  } catch (error) {
    console.error(error);
    if (error instanceof AxiosError) {
      commitAddNotification(store, {
        messageKey: sharedMessages.responseError,
        messageValues: {
          detail: error.response?.data ?? error.message,
        },
        color: 'error',
      });
    } else {
      commitAddNotification(store, {
        messageKey: sharedMessages.genericError,
        color: 'error',
      });
    }
  }
};

const handleResetDeleteTargetIpAddress = (withRefresh?: boolean) => {
  deleteTargetIpAddress.value = undefined;

  if (withRefresh) {
    emits('refresh:ipAddressList');
  }
};

return { __sfc: true,emits, m, hasPermission, P, deleteTargetIpAddress, editTargetWhitelistIp, editName, isValidEditForm, isNameChanged, openEditDialog, closeEditDialog, updateWhitelistIpName, handleResetDeleteTargetIpAddress, isValidLength, formatToDate, sharedMessages, DeleteIpAddress }
}

})